import { createStore } from "redux";
import CombinedReducer from "./reducers/CombinedReducer";

export default createStore(CombinedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
